import {
  memberTypeEntries,
  memberTypeKeys,
  memberTypeValues,
  memberStatusType,
  memberStatusTypes,
  memberStatusTypesWithAll,
  allAuctionType,
  allMessageType,
  auctionType,
  auctionTypes,
  auctionTypesWithAll,
  defaultAuctionTypeValue,
  memberType,
  messageType,
  messageTypeEntries,
  messageTypeKeys,
  messageTypeValues,
  messageTypeValuesWithAll,
  routeParams,
  getPath,
  routePathKeys,
} from '.';
import { default as providers } from './providers';

export default {
  messageTypes: {
    allMessageType,
    messageType,
    messageTypeEntries,
    messageTypeKeys,
    messageTypeValues,
    messageTypeValuesWithAll,
  },
  auctionTypes: {
    allAuctionType,
    auctionType,
    auctionTypes,
    auctionTypesWithAll,
    defaultAuctionTypeValue,
  },
  memberTypes: {
    memberType,
    memberTypeKeys,
    memberTypeEntries,
    memberTypeValues,
    memberStatusType,
    memberStatusTypesWithAll,
    memberStatusTypes,
  },
  providers,
  routes: {
    routeParams,
    getPath_DEFAULT_NOARGS: getPath(),
    example_auctionProducts_FOR_IT_TEST_AUCTION: getPath('auctionProducts', {
      auctionId: 'c5857203-487c-eb11-80d1-005056afaeea',
    }),
    routePathKeys,
  },
};
